<template>
  <DateRangePicker
    ref="picker"
    v-model="internalValue"
    :locale-data="locale"
    :ranges="ranges"
    :opens="opens"
    :max-date="maxDate"
    v-bind="$attrs"
    class="w-full vue-daterange-picker-custom"
    v-on="$listeners"
  >
    <template v-slot:input="picker">
      <div
        class="flex items-center justify-between w-full h-[36px] px-[14px] py-[10px] bg-[#FFFFFF] border-[1px] border-[#D0D5DD] rounded-[8px] shadow-[0px_1px_2px_0px_#0000001A] cursor-pointer select-none hover:border-[#B2DDFF] transition-colors duration-200"
      >
        <span class="text-[14px] leading-[20px] font-normal text-[#101828] truncate">
          {{ formattedDateRange(picker) }}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-[20px] h-[20px] text-[#101828] shrink-0 ml-[8px]"
        >
          <rect
            x="3"
            y="4"
            width="18"
            height="18"
            rx="3"
            ry="3"
          />
          <line
            x1="16"
            y1="2"
            x2="16"
            y2="6"
          />
          <line
            x1="8"
            y1="2"
            x2="8"
            y2="6"
          />
          <line
            x1="3"
            y1="10"
            x2="21"
            y2="10"
          />
        </svg>
      </div>
    </template>
  </DateRangePicker>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import { today, last30 } from '@/store/helpers'
import { datePickerRangeGeneral } from '../../../config'

export default {
  name: 'DateRangeFilter',
  components: {
    DateRangePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        startDate: last30,
        endDate: today,
      }),
    },
    opens: {
      type: String,
      default: 'left',
    },
    format: {
      type: [String, Function],
      default: 'DD MMMM YYYY',
    },
    placeholder: {
      type: String,
      default: 'Pilih Tanggal',
    },
    ranges: {
      type: [Object, Boolean],
      default: () => datePickerRangeGeneral(),
    },
    locale: {
      type: Object,
      default: () => ({
        format: 'dd/mm/yyyy',
        daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
      }),
    },
    maxDate: {
      type: [Date, String, Object],
      default: null,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    formattedDateRange(picker) {
      const start = picker && picker.startDate ? picker.startDate : (this.value && this.value.startDate)
      const end = picker && picker.endDate ? picker.endDate : (this.value && this.value.endDate)

      if (!start || !end) {
        return this.placeholder
      }

      if (typeof this.format === 'function') {
        return this.format(start, end)
      }

      const formatStr = this.format || 'DD MMMM YYYY'
      const startStr = moment(start).locale('id').format(formatStr)
      const endStr = moment(end).locale('id').format(formatStr)

      return `${startStr} - ${endStr}`
    },
  },
}
</script>

<style lang="scss">
.vue-daterange-picker-custom {
  width: 100% !important;
  display: block;

  .form-control {
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    height: auto !important;
    line-height: normal !important;
  }
}
</style>
